import type { ReactNode } from "react";

export function ModuleHeader({
  eyebrow,
  title,
  description,
  action,
  compact = false,
}: {
  eyebrow: string;
  title: string;
  description: string;
  action?: ReactNode;
  compact?: boolean;
}) {
  return (
    <div className={`module-header${compact ? " is-compact" : ""}`}>
      <div>
        {compact ? null : <span className="section-kicker">{eyebrow}</span>}
        <h1>{title}</h1>
        {compact ? null : <p>{description}</p>}
      </div>
      {action}
    </div>
  );
}
